import { isNil } from 'lodash';

import determinePipelineStatus from './determinePipelineStatus';

export default function mergeIonAndControlPipelines(ionPipelines, controlPipelines) {
  return ionPipelines.map(ionPipeline => {
    const controlPipeline = controlPipelines.find(controlPipeline => controlPipeline.pipelineId === ionPipeline.id);

    const status = determinePipelineStatus(ionPipeline, controlPipeline);

    return {
      status,
      lastDeployed: controlPipeline.pipeline?.createdAt,
      hasPipelineFilter: !isNil(controlPipeline.pipeline?.filter),
      hasPipelineTransform: !isNil(controlPipeline.pipeline?.transform),
      hasPipelineEventSplit: !isNil(controlPipeline.pipeline?.eventSplit),
      ...ionPipeline,
    };
  });
}
